/**
 * Returns 'yyyy-MM-dd' of string, removing timezone if it exists
 * @param {string} dateString
 */
const formatDateStringNoTimezone = (dateString) => {
    return dateString === null || dateString === void 0 ? void 0 : dateString.substring(0, 10);
};
export default formatDateStringNoTimezone;
